import { Breadcrumbs } from "@/components/breadcrumbs";
import { StatusDot } from "@/components/status-dot";
import { ThemeToggle } from "@/components/theme-toggle";
import { UserMenu } from "@/components/user-menu";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";

// Adapted from connect-v2's dashboard header: no search, notifications or theme selector.
export function Header() {
	return (
		<header className="bg-background/95 supports-[backdrop-filter]:bg-background/80 sticky top-0 z-20 flex h-14 shrink-0 items-center justify-between gap-2 border-b px-2 backdrop-blur md:px-4">
			<div className="flex min-w-0 flex-1 items-center gap-2 pl-2 md:pl-0">
				<SidebarTrigger className="-ml-1 hidden md:inline-flex" />
				<Separator orientation="vertical" className="mr-2 hidden h-4 md:block" />
				<Breadcrumbs />
			</div>
			<div className="flex items-center">
				<StatusDot />
				<ThemeToggle />
				<UserMenu />
			</div>
		</header>
	);
}
